<div class="product" #productElement>

    <div class="info" (click)="showComposition()" *ngIf="product.comp">
        <img src="assets/images/arrows/info.png" alt="info">
    </div>
    <!-- <div class="main-img"
        [ngStyle]="(product.avatar)?{background: 'url(https://api.helpyfood.com/products/' + product.avatar + ')'}:''"> -->
    <!-- <img [id]="product.id" class="zoom" [src]="product.avatar|absolutePath:'products'" [hidden]="!loadAvatar"
            (load)="loadAvatar=true" [alt]="'Livraison '+product.familyName+' '+product.name"
            [title]="'Livraison '+product.familyName+' '+product.name" /> -->
    <div class="main-img" [ngClass]="{loading:!loadAvatar}">
        <img [src]="product.avatar|absolutePath:'products'" [hidden]="!loadAvatar" (load)="loadAvatar=true"
            [alt]="'Livraison '+product.familyName+' '+product.name"
            [title]="'Livraison '+product.familyName+' '+product.name" />
    </div>
    <!-- </div> -->
    <div class="compositions back" *ngIf="product.showcomp">
        <div class="scr">
            <ul>
                <li *ngFor="let comp of product.comp|toArray">
                    {{comp}}
                </li>
            </ul>
        </div>
    </div>
    <div class="product-body">
        <h2>{{product.name}}</h2>
    </div>
    <div class="product-footer">
        <div class="size vcenter" *ngIf="product.sizes.length > 0">
            <div>
                <select class="form-control" [(ngModel)]="product.size" *ngIf="product.sizes.length>1">
                    <option *ngFor="let s of product.sizes;let j=index" [value]="j">{{s.size}}</option>
                </select>
                <p *ngIf="product.sizes.length==1 && product.sizes[0].level">{{product.sizes[0].size}}</p>
            </div>
            <div>
                <p class="price pull-right">
                    {{product.sizes[product.size].price}}€
                </p>
            </div>
        </div>
        <ng-container *ngIf="!siteClose">
            <div class="row" *ngIf="product.validPeriod==1">
                <div *ngIf="product.sizes[product.size]?.available">
                    <button (click)="addToBasket()" class="btn col-xs-12 add" [disabled]="siteClose">
                        Ajouter au panier
                        <img src="assets/imgs/addBasket.png" alt="" srcset="">
                    </button>
                </div>
                <div class="indisponible" *ngIf="!product.sizes[product.size]?.available">
                    <div class="alert alert-danger text-center">
                        Indisponible
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="product.validPeriod==0">
                <div class="col-xs-12 indisponible">
                    <div class="alert alert-danger text-center">
                        <ng-container *ngIf="product.elementTime==1">Disponible midi uniquement</ng-container>
                        <ng-container *ngIf="product.elementTime==3">Disponible soir uniquement</ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="siteClose">
            <div class="row">
                <div class="indisponible">
                    <div class="alert alert-danger text-center">
                        Restaurant fermé
                    </div>
                </div>
            </div>
        </ng-container>

    </div>
</div>
<div id="myModal" class="modal">
    <span class="close">&times;</span>
    <img class="modal-content" id="img01" [src]="src">
    <div id="caption"></div>
</div>
<ng-template #template>
    <div class="modal-header compositions">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closemodel()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Composition {{product.name}}</h4>
    </div>
    <div class="modal-body">
        <ul class="list-comp">
            <li *ngFor="let comp of compositions">
                {{comp}}
            </li>
        </ul>
    </div>
</ng-template>